module.exports = __webpack_public_path__ + "img/MED_FISH@300x.115ee33d.png";